<template>
  <div>
    <notifications class="block-user-employee" group="block-user-employee" position="bottom right">
      <template slot="body" slot-scope="{ item }">
        <div class="block-user-employee-content">
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
              fill="#12C971"
            />
            <path
              d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
              fill="#12C971"
            />
          </svg>
          <div class="block-user-employee-content-description">
            Пользователь <span class="block-user-employee-content-description-bold">{{ item.data.userName }}</span> для
            сотрудника <span class="block-user-employee-content-description-bold">{{ item.data.employeeName }}</span>
            {{ item.data.blockType }}
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="block-user-employee" group="change-status-employee" position="bottom right">
      <template slot="body" slot-scope="{ item }">
        <div class="block-user-employee-content">
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
              fill="#12C971"
            />
            <path
              d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
              fill="#12C971"
            />
          </svg>
          <div class="block-user-employee-content-description">
            Статус сотрудника
            <span class="block-user-employee-content-description-bold">{{ item.data.employeeName }}</span> успешно
            изменён
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="block-user-employee" group="success-message" position="bottom right">
      <template slot="body" slot-scope="{ item }">
        <div class="block-user-employee-content">
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
              fill="#12C971"
            />
            <path
              d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
              fill="#12C971"
            />
          </svg>
          <div class="success-message-content-description" v-html="item.data.textMessage">
            {{ item.data.textMessage }}
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="calculation-success" group="calculation-success-message" position="bottom right">
      <template slot="body" slot-scope="{ item }">
        <div class="calculation-success-content">
          <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
              fill="#12C971"
            />
            <path
              d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
              fill="#12C971"
            />
          </svg>
          <div class="success-message-content-description" v-html="item.data.textMessage">
            {{ item.data.textMessage }}
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="error-message" group="error-message" position="bottom right">
      <template slot="body" slot-scope="{ item }">
        <div class="error-message-content">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>
          <div class="error-message-content-description" v-html="item.data.textMessage">
            {{ item.data.textMessage }}
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="error-message center-error-message" group="center-error-message" position="center center">
      <template slot="body" slot-scope="{ item }">
        <div class="error-message-content">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>
          <div class="error-message-content-description" v-html="item.data.textMessage">
            {{ item.data.textMessage }}
          </div>
        </div>
      </template>
    </notifications>
    <notifications class="file-error-message" group="file-error-message" position="center">
      <template slot="body" slot-scope="{ item }">
        <div class="error-message-content">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="6.5" stroke="#FF238D" />
            <circle cx="7" cy="10" r="1" fill="#FF238D" />
            <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D" />
          </svg>
          <div class="error-message-content-description" v-html="item.data.textMessage">
            {{ item.data.textMessage }}
          </div>
        </div>
      </template>
    </notifications>
  </div>
</template>

<script>
import Vue from "vue";
import Notifications from "vue-notification";

Vue.use(Notifications);

export default {
  name: "app-notifications",
};
</script>

<style lang="scss" scoped>
.block-user-employee {
  right: 20px !important;
  bottom: 67px !important;
  width: 380px !important;
  background: #d0f4e3;
  box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px;

  & ::v-deep span .vue-notification-wrapper {
    padding: 14px 21px 14px 27px !important;
  }

  &-content {
    display: flex;
    align-items: center;

    & svg {
      margin-right: 13px;
    }

    &-description {
      max-width: 293px;
      font-family: Fira Sans;
      font-size: 13px;
      line-height: 120%;

      &-bold {
        font-weight: 500;
      }
    }
  }

  @media screen and (max-width: 700px) {
    width: 280px !important;
    bottom: 22px !important;

    &-description {
      max-width: 206px;
    }
  }
}

.calculation-success {
  right: 20px !important;
  max-width: calc(100vw - 40px);
  bottom: 90px !important;
  width: auto;
  height: auto;
  background: #d0f4e3;
  box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px;
  & ::v-deep span .vue-notification-wrapper {
    padding: 14px 21px 14px 27px !important;
  }

  &-content {
    display: flex;
    align-items: center;

    & svg {
      margin-right: 13px;
    }

    &-description {
      max-width: 220px;
      font-family: Fira Sans;
      font-size: 13px;
      line-height: 120%;
      white-space: normal;
      overflow-wrap: break-word;

      &-bold {
        font-weight: 500;
      }
    }
  }

  @media screen and (min-width: 768px) {
    left: auto;
    max-width: 460px;
    bottom: 40px !important;
  }
}

.success-message {
  right: 20px !important;
  bottom: 43px !important;
  width: auto;
  height: auto;
  background: #d0f4e3;
  box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px;

  & ::v-deep span .vue-notification-wrapper {
    padding: 14px 21px 14px 27px !important;
  }

  &-content {
    display: flex;
    align-items: center;

    & svg {
      margin-right: 13px;
    }

    &-description {
      max-width: 220px;
      font-family: Fira Sans;
      font-size: 13px;
      line-height: 120%;
      white-space: normal;
      overflow-wrap: break-word;

      &-bold {
        font-weight: 500;
      }
    }
  }

  @media screen and (max-width: 700px) {
    width: 280px !important;
    bottom: 22px !important;

    &-description {
      max-width: 206px;
    }
  }
}

.error-message {
  right: 20px !important;
  bottom: 43px !important;
  width: auto;
  background: #ffe6f2;
  box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px;

  & ::v-deep span .vue-notification-wrapper {
    padding: 14px 21px 14px 27px !important;
  }

  &-content {
    display: flex;
    align-items: center;

    & svg {
      margin-right: 13px;
      min-width: 14px !important;
      width: 14px !important;
      height: 14px !important;
    }

    &-description {
      max-width: 280px;
      font-family: Fira Sans;
      font-size: 13px;
      line-height: 120%;

      &-bold {
        font-weight: 500;
      }
    }
  }

  @media screen and (max-width: 700px) {
    width: 280px !important;
    bottom: 22px !important;

    &-description {
      max-width: 206px;
    }
  }
}

.center-error-message {
  top: 50%;
  bottom: auto !important;
  transform: translateY(-50%);
}

.file-error-message {
  top: 40%;
  width: auto;
  background: #ffe6f2;
  box-shadow: 0px 4px 16px rgba(0, 15, 38, 0.25);
  border-radius: 6px;

  & ::v-deep span .vue-notification-wrapper {
    padding: 14px 21px 14px 27px !important;
  }

  &-content {
    display: flex;
    align-items: center;

    & svg {
      margin-right: 13px;
      min-width: 14px !important;
      width: 14px !important;
      height: 14px !important;
    }

    &-description {
      max-width: 280px;
      font-family: Fira Sans;
      font-size: 13px;
      line-height: 120%;

      &-bold {
        font-weight: 500;
      }
    }
  }

  @media screen and (max-width: 700px) {
    width: 280px !important;

    &-description {
      max-width: 206px;
    }
  }
}
</style>
